import { getRequest,postRequest } from "@/http/request_service.js";
import { API } from "@/api/api.js"

export const recommendList=(params)=>{
    return getRequest(API.recommendList,params);
}
export const memberExportReport=(params)=>{
    return postRequest(API.memberExportReport,params);
}
